import { Localized, useLocalization } from '@fluent/react';

import { InputFormik } from '#/components/controls/Input';

const RequesetPasswordResetForm: React.FC<RequesetPasswordResetFormProps> = () => {
  const { l10n } = useLocalization();

  return (
    <Localized id="username" attrs={{ placeholder: true }}>
      <InputFormik label={l10n.getString('username')} name="username" type="text" />
    </Localized>
  );
};
export type RequesetPasswordResetFormProps = {};

export default RequesetPasswordResetForm;
